import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatDate } from '@/lib/utils';

interface AuditEntry {
  id: string;
  user: { id: string; name: string; email: string; role: 'rep' | 'manager' };
  entityType: 'topic' | 'document' | 'brand_voice';
  entityId: string;
  action: 'create' | 'update' | 'delete';
  diff: unknown;
  createdAt: string;
}

export function AuditPage() {
  const list = useQuery({
    queryKey: ['audit'],
    queryFn: () => api<{ items: AuditEntry[] }>('/api/v1/audit', { query: { limit: 100 } }),
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Audit log</h1>
      <p className="text-sm text-muted-foreground">
        Every change to topics, brand voice, and knowledge documents.
      </p>
      <div className="space-y-2">
        {list.data?.items.map((e) => (
          <Card key={e.id} className="p-4">
            <div className="flex justify-between flex-wrap gap-2 text-sm">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-medium">{e.user.name}</span>
                <Badge variant="outline">{e.action}</Badge>
                <Badge variant="secondary">{e.entityType}</Badge>
                <code className="text-xs text-muted-foreground">{e.entityId}</code>
              </div>
              <span className="text-xs text-muted-foreground">{formatDate(e.createdAt)}</span>
            </div>
            <pre className="mt-2 text-xs bg-muted p-2 rounded overflow-x-auto">
              {JSON.stringify(e.diff, null, 2)}
            </pre>
          </Card>
        ))}
        {list.data && list.data.items.length === 0 && (
          <p className="text-muted-foreground text-sm">No audit entries yet.</p>
        )}
      </div>
    </div>
  );
}
